export const parseTemplate = ({ template = '', subject = '', id = '' }) => {
  const report_type = id.replace('default_', '').replace('_month_report', '').replace('_daily_report', '')
  const wholeType = id.includes('month_report') ? 'month' : 'daily'
  let title_prefix = wholeType === 'month' ? '{{YYYY-MM}} {{project}}' : '{{YYYY-MM-DD}} {{project}}'
  let template_header = ''
  let template_footer = ''
  const title = subject.substring(subject.lastIndexOf('}} ') + 3)
  if (report_type === 'system') {
    title_prefix = wholeType === 'month' ? '{{YYYY}}' : '{{YYYY-MM-DD}}'
  } else if (report_type === 'domain') {
    title_prefix = wholeType === 'month' ? '{{YYYY-MM}} {{domain}}' : '{{YYYY-MM-DD}} {{domain}}'
  }
  const hStart = template.indexOf('<p style="font-weight:bold" class="edit-header">')
  const hEnd = template.indexOf('</p>')
  if (hStart > 0 && hEnd > 0) {
    template_header = template.substring(hStart + 48, hEnd)
  }
  // 可编辑尾部区域
  // 改为RichEditor之前的模板格式
  const qStart = template.lastIndexOf('<p style="font-size:22px;font-weight:bold;text-decoration:underline">Q&A')
  if (qStart > 0) {
    template_footer += `<p style="text-align: start;"><span style="font-size: 22px;"><u><strong>Q&amp;A</strong></u></span></p><p style="text-indent: 2em; text-align: start;">Q: 我该如何查看具体的费用信息？</p><p style="text-indent: 2em; text-align: start;">A: 可以在左边导航栏-费用-${report_type === 'project' ? '项目' : '域'}, 点击${report_type === 'project' ? '项目' : '域'}就可以看到具体的资源费用信息</p><p style="text-indent: 2em; text-align: start;">Q: 我该如何查看优化建议？</p><p style="text-indent: 2em; text-align: start;">A: 可以在左边导航栏-优化建议-建议列表中进行查看</p><p style="text-indent: 2em; text-align: start;">Q：我该如何优化？</p><p style="text-indent: 2em; text-align: start;">A: 根据优化建议提供的资源列表，为了更好的利用资源，比如您这边资源配置为16C32G，我们建议可以先根据应用的特性逐步对资源进行降配，如12C24G，8C16G等</p>`
  }
  const fStart = template.lastIndexOf('<p style="text-indent:16px" class="edit-footer">')
  const fEnd = template.lastIndexOf('</p>')
  if (fStart > 0 && fEnd > 0 && fEnd > fStart) {
    let str = template.substring(fStart + 48, fEnd)
    if (!str.includes('</')) {
      str = `<p style="text-indent: 2em; text-align: start;">${str}</p>`
    }
    template_footer += str
  }
  // 改为RichEditor之后的模板格式
  const newfStart = template.lastIndexOf('<div class="edit-footer">')
  const newfEnd = template.indexOf('</div>', newfStart)
  if (newfStart > 0 && newfEnd > 0 && newfEnd > newfStart) {
    template_footer = template.substring(newfStart + 25, newfEnd)
  }
  return { template, title, title_prefix, template_header, template_footer, report_type }
}
